import { useCartAtom, useFormMessageAtom } from '$src/hooks/state';

export const useBaseApiUrl = (): string | undefined => {
  const { formMessage } = useFormMessageAtom();
  const { cart: { id: cartId } = {} } = useCartAtom();
  return formMessage?.shopId && cartId ? `/api/${formMessage.shopId}/${cartId}` : undefined;
};
